import dynamic from 'next/dynamic'

import { Container, Row, Column } from './base/gridview'
import Category from './widgets/category-select/category-select'

const Button = dynamic(() => import('./base/button'))
const Heading = dynamic(() => import('./base/heading'))
const Html = dynamic(() => import('./base/html'))
const Image = dynamic(() => import('./base/image'))
const Section = dynamic(() => import('./base/section'))
const SuggestionOpt = dynamic(() => import('./widgets/optScreen'))
const SuggestionOtpConfirmation = dynamic(
  () => import('./widgets/optConfirmation')
)
const Workshop = dynamic(() => import('./widgets/workshop'))
const userForm = dynamic(() => import('./widgets/userForm'))
const SuccessPage = dynamic(() => import('./widgets/success-page'))
const ProjectForm = dynamic(() => import('./widgets/projectForm'))
const TkyfOpt = dynamic(() => import('./widgets/tkyfOptScreen'))
const TkyfUser = dynamic(() => import('./widgets/tkyfUserForm'))
const TkySucces = dynamic(() => import('./widgets/tkyf-success-page'))
const TkyfOptConfirmation = dynamic(
  () => import('./widgets/tkyfOptConfirmation')
)

export default function getter(name: string) {
  switch (name) {
    case 'heading':
      return Heading
    case 'html':
      return Html
    case 'container':
      return Container
    case 'row':
      return Row
    case 'section':
      return Section
    case 'column':
      return Column
    case 'button':
      return Button
    case 'image':
      return Image
    case 'section':
      return Section
    case 'title-desc':
      return SuggestionOpt
    case 'otp-confirmation':
      return SuggestionOtpConfirmation
    case 'workshop-form':
      return Workshop
    case 'user-form':
      return userForm
    case 'category-select':
      return Category
    case 'success':
      return SuccessPage
    case 'project-form':
      return ProjectForm
    case 'tkyf-giris':
      return TkyfOpt
    case 'tkyf-confirmation':
      return TkyfOptConfirmation
    case 'tkyf-user':
      return TkyfUser
    case 'tkyf-success':
      return TkySucces
  }
}
